import { render, staticRenderFns } from "./FilterDisplay.vue?vue&type=template&id=542b54d5&"
import script from "./FilterDisplay.vue?vue&type=script&lang=js&"
export * from "./FilterDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FilterDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports